import { useQuery } from '@tanstack/react-query';

import axios from 'axios';
import { ExtractFnReturnType, QueryConfig } from 'lib/react-query';

import { Dish } from 'types';

export const getDishesByAnalyzer = async (
  analyzerId: number
): Promise<Dish[]> => {
  if (analyzerId < 1) return [];
  const { data }: { data: Dish[] } = await axios.get(
    `/api/dishes/analyzers/${analyzerId}`
  );
  return data as Dish[];
};

type QueryFnType = typeof getDishesByAnalyzer;

type UseDishesByAnalyzerOptions = {
  analyzerId: number;
  config?: QueryConfig<QueryFnType>;
};

export const useDishesByAnalyzer = ({
  analyzerId,
  config,
}: UseDishesByAnalyzerOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['dishes', 'analyzers', analyzerId],
    queryFn: () => getDishesByAnalyzer(analyzerId),
    ...config,
  });
};
